import React, { Component } from "react";
import './styles.css';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { dateUtils, dateFieldCombo } from '../../common/DateUtils'
import moment from 'moment'


const tiposItem = [
    "LP",
    "L",
    "P",
  ];

class Cupom extends Component {
    constructor(props) {
        super(props);
        const params = this.props.location

        this.state = {
            id: params.pathname.split('/')[2],
            empresa: '',
            cliente: '',
            quantidade: 0,
            vendas: [],
            itens: [],
            combos: [],
            printDate: '',
        }
    }

    async componentDidMount() {
        this.setState({isLoading: true })
        
        const id = this.state.id

        
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 

        const empresa = await api.get('/api/empresa', {
            headers: {
                'x-access-token':token,
            }
        })

        const vendas = await api.get(`/api/vendas/${ id }`, {
            headers: {
                'x-access-token':token,
            }
        })

  
        const cliente = await api.get(`/api/pessoa/${ vendas.data[0][0].cliente }`, {
            headers: {
                'x-access-token':token,
            }
        })

        var total_quantidade = 0; /*= vendas.data[1].reduce(function (total, currentValue) {
            return currentValue.cupom ?? Number(total) + Number(currentValue.quantidade);
          }, 0);*/

        for (let index = 0; index <  vendas.data[1].length; index++) {
            const element =  vendas.data[1][index];
            total_quantidade += element.cupom ? element.quantidade : 0 
        }

        const { data } = await api.get('/api/antecipada', {
            headers: {
                'x-access-token':token,
            }
        });
        const combos = await data.filter(function (value) {
            return value.idcliente == cliente.data.id; 
        });
         console.log(vendas)
        this.setState({
            empresa: empresa.data[0],
            emissao: vendas.data[0][0].emissao,
            emissaoh: vendas.data[0][0].emissaoh,
            quantidade: total_quantidade,
            cliente: cliente.data,
            vendas: vendas.data[0],
            itens: vendas.data[1].sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0)),
            combos: combos,
            printDate: new Date().toLocaleDateString('pt-BR', {timeZone: 'America/Sao_Paulo'}) + '-' + new Date().toLocaleTimeString('pt-BR', {timeZone: 'America/Sao_Paulo'})
        }) 
        
        
        window.print();
    }

    render() {
        return  (
            <>
                <table class="printer-ticket">
                    <thead>
                        <tr>
                            <th colspan="4">
                            <b>{ this.state.empresa.razao }</b><br/>
                                {this.state.empresa.endereco} - {this.state.empresa.numero}  {this.state.empresa.bairro}<br/>
                                Fone: {this.state.empresa.fone}<br/>
                                {this.state.empresa.cnpj}    
                                                     
                            </th>
                        </tr>
                        <tr>
                            <th colspan="4">
                                <b>Cliente:</b> { this.state.cliente.id } { this.state.cliente.razao } - <b>Contato:</b> { this.state.cliente.fone } 
                                
                            </th>                        
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Item</th>
                            <th>Un</th>
                            <th>Qtd</th>
                            <th align="right">Total</th>
                        </tr>
                        {
                            this.state.itens.map((item) => 
                                <>
                                    <tr>
                                        <td  align="left">{ item.nome + ' (' + tiposItem[Number(item.tipo)-1] + ')' }</td>
                                        <td align="center">{ item.preco ? Number(item.preco).toFixed(2) : '0.00' }</td>
                                        <td align="left">{ item.quantidade ? Number(item.quantidade).toFixed(2) : '0.00' }</td>
                                        <td align="right">R$ { item.total ? Number(item.total).toFixed(2) : '0.00' }</td>                                       
                                    </tr>
                                </>
                            )
                            
                        }  
                                   
                    </tbody>
                    {
                        this.state.combos.length ?
                        <tbody>
                            <tr class="sup ttu p--0">
                                <td colspan="4">
                                    <b>Combo Em Aberto</b>
                                </td>
                            </tr>  
                        
                            {
                                this.state.combos.map((combo) => 
                                    <>
                                        <tr>
                                            <td  align="left">{ combo.grupo + ' (' + tiposItem[Number(combo.tipo)-1] + ')' }</td>
                                            <td align="center">{ combo.solicitada ? Number(combo.solicitada).toFixed(2) : '0.00' }</td>
                                            <td align="left">{ combo.utilizado ? Number(combo.utilizado).toFixed(2) : '0.00' }</td>
                                            <td align="right">{ combo.solicitada > 0 && combo.utilizado > 0 ? Number(combo.solicitada - combo.utilizado).toFixed(2) : Number(combo.solicitada).toFixed(2) }</td>  
                                                                                 
                                        </tr>
                                        <tr class="sup ttu p--0">
                                            <td colspan="10">
                                                <b>ATENÇÃO:</b> { combo.nao_expirar ? 'Este combo não tem prazo de vencimento e finaliza apenas quando acabar o estoque.' : combo.dias_desde_antecipacao > 1 ? `Faltam ${combo.dias_desde_antecipacao} dias para vence seu combo.` : `Vence em ${combo.dias_desde_antecipacao} dia.` }
                                            </td>
                                        </tr>  

                                    </>
                                )
                                
                            }  
                            
                          
                        </tbody> :
                        ''
                    }
                    {
                        //`${Number(((row.solicitada/20)*30)- row.dias_desde_antecipacao).toFixed(0)} dias` 
                    }
                    
                    <tfoot>
                        {
                            this.state.vendas.map((venda) => 
                                <>
                                    <tr class="sup ttu p--0">
                                        <td colspan="4">
                                            <b>Totais</b>
                                        </td>
                                    </tr>  
                                    <tr class="ttu">
                                        <td colspan="3">Quantidade</td>
                                        <td align="right">{ this.state.quantidade.toFixed(2) }</td>
                                    </tr>    
                                    <tr class="ttu">
                                        <td colspan="3">Sub-total</td>
                                        <td align="right">R$ { (( venda.total + venda.desconto ) - venda.acrescimo).toFixed(2) }</td>
                                    </tr>
                                    <tr class="ttu">
                                        <td colspan="3">Acrescimo + TX Entrega</td>
                                        <td align="right">R$ { venda.acrescimo.toFixed(2) }</td>
                                    </tr>
                                    <tr class="ttu">
                                        <td colspan="3">Desconto</td>
                                        <td align="right">R$ { venda.desconto.toFixed(2) }</td>
                                    </tr>
                                    <tr class="ttu">
                                        <td colspan="3">Total</td>
                                        <td align="right">R$ { venda.total.toFixed(2)  }</td>
                                    </tr>
                                    {
                                        venda.observacao ?
                                        <tr>
                                            <td  colspan="4">Obs: { venda.observacao }</td>
                                        </tr> :'' 
                                    }
                                    <tr class="sup">
                                        <td colspan="4" align="center">
                                            <b>Pedido: { venda.numero }</b> - <b>Emissão: </b>{  dateUtils(this.state.emissao) } - { this.state.emissaoh.replace('.000000', '')} <br/>LP - Lavar e Passar | L - Lavar |  P - Passar                                            
                                        </td>
                                    </tr>   
                                    <tr class="sup">
                                        <td colspan="4" align="center">
                                            <b>Data/Hora da impressão: { this.state.printDate } </b>  
                                        </td>
                                    </tr>  
                                    
                                    <tr class="sup">
                                        <td colspan="4" align="center">
                                            <b>LEIA COM ATENÇÃO</b>  
                                        </td>
                                    </tr>  
                                    <tr>
                                            <td  colspan="4"  align="justify">ANTES DE FAZERMOS LAVAGEM DAS PEÇAS FAREMOS UMA ANALISE E CASO ENCONTRE ALGUMA AVARIA ENVIAREMOS FOTOS VIA WHATSAPP E AGUARDAREMOS AUTORIZAÇÃO.</td>
                                    </tr>   
                                    <tr>
                                            <td  colspan="4"  align="justify"><br/>NÃO NOS RESPONSABILIZAMOS POR:<br/>
                                            MIGRAÇÃO DE CORES, DESCOSTURAS, QUEDA DE ACESSORIOS, ROMPIMENTO DE FIBRAS.<br/>
                                            PEÇAS COM MOFO PODERÁ SE DANIFICAR, MANCHAS E ODOR IMPREGNADOS NÃO SAIRÃO 100% A LAVANDERIA SE RESERVA AO DIREITO DE DOAR AS PEÇAS QUE FICAREM NA LOJA APÓS 90 DIAS.
                                            
                                            </td>
                                    </tr>  
                                    <tr>
                                            <td  colspan="4"  align="justify"><br/>PRAZO PARA RECLAMAÇÕES E DE 24 HORAS APOS O RECEBIMENTO DA ROUPA.<br/><br/>
                                            DECLARO QUE LI, E ESTOU CIENTE E AUTORIZO O SERVIÇO.<br/>
                                                                              
                                            </td>
                                    </tr>    
                                        
                                </>
                            )
                        }                       
                    </tfoot>
                </table>
            </  >
        )
    }
}

export default Cupom;